// @flow

import * as React from 'react';
import classNames from 'classnames';

export type AnnotationStyles = 'DEFAULT' | 'SUCCESS' | 'ERROR' | 'INFO' | 'WARNING';

const ANNOTATION_STYLES: {
  [AnnotationStyles]: {
    backgroundColor: string,
    hoverBackgroundColor: string,
    borderColor: string,
    iconColor: string,
    icon: string
  }
} = {
  DEFAULT: {
    backgroundColor: "build-scheduled",
    hoverBackgroundColor: "build-scheduled-dark",
    borderColor: "build-scheduled",
    iconColor: "white",
    icon: "pencil"
  },
  SUCCESS: {
    backgroundColor: "build-passed",
    hoverBackgroundColor: "build-passed-dark",
    borderColor: "build-passed",
    iconColor: "white",
    icon: "check"
  },
  ERROR: {
    backgroundColor: "build-failed",
    hoverBackgroundColor: "build-failed-dark",
    borderColor: "build-failed",
    iconColor: "white",
    icon: "times"
  },
  INFO: {
    backgroundColor: "build-skipped",
    hoverBackgroundColor: "build-skipped-dark",
    borderColor: "build-skipped",
    iconColor: "white",
    icon: "info"
  },
  WARNING: {
    backgroundColor: "build-running",
    hoverBackgroundColor: "build-running-dark",
    borderColor: "build-running",
    iconColor: "white",
    icon: "warning"
  }
};

type Props = {
  annotation: {
    context: string,
    style: AnnotationStyles,
    body: {
      html: ?string
    }
  }
};

export default class Annnotation extends React.PureComponent<Props> {
  render() {
    const annotationId = `annotation-${this.props.annotation.context}`;

    const styles = ANNOTATION_STYLES[this.props.annotation.style];

    return (
      <div
        id={annotationId}
        className={classNames(
          'rounded flex items-stretch border mb4',
          `border-${styles.borderColor}`
        )}
      >
        <a
          href={`#${annotationId}`}
          className={classNames(
            'flex-none flex pt3 border-right',
            `border-${styles.borderColor}`,
            `bg-${styles.backgroundColor}`,
            `hover-bg-${styles.hoverBackgroundColor}`
          )}
          style={{
            width: 30
          }}
        >
          <div className="center flex-auto">
            <i
              className={classNames(
                'fa',
                `fa-${styles.icon}`,
                styles.iconColor
              )}
            />
          </div>
        </a>
        <div className="flex-auto">
          <div
            className="m3 annotation-body"
            dangerouslySetInnerHTML={{
              __html: (
                (this.props.annotation.body && this.props.annotation.body.html)
                  ? this.props.annotation.body.html
                  : ''
              )
            }}
          />
        </div>
      </div>
    );
  }
}
